import { getLocaleFromCookies } from './cookies'

type FormatCurrencyOptions = {
    locale?: string
    currency?: string
    minimumFractionDigits?: number
  }

export function formatCurrency(
  value: number,
  options: FormatCurrencyOptions = {}
) {
  const localeFromCookie = getLocaleFromCookies()
  const localeForFormat = localeFromCookie === 'en' ? 'en-US' : 'id-ID'
  
  const {
    locale = localeForFormat,
    currency = 'IDR',
    minimumFractionDigits = 0,
  } = options

  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '-'
  }

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(value)

  if (locale === 'id-ID' && currency === 'IDR') {
    return formatted.replace('IDR', 'Rp')
  }

  return formatted

}
